import * as React from "react";
import {
    List, Datagrid, Edit, Create, SimpleForm, TextField, EditButton, TextInput,
    required, ImageInput, ImageField, DateInput, FunctionField,
    BooleanInput, TranslatableInputs, useEditContext,
    SelectArrayInput, ReferenceArrayInput, useTranslate, useLocaleState
} from 'react-admin';

// Components
import EmptyList from "../components/misc/EmptyList";
import InputRow from "../components/form/InputRow";
import UpcomingEventsSelectInput from "../components/form/UpcomingEventsSelectInput";

// Entity
const entity = "groupEvents";

export const GroupEventList = (props) => {
    const translate = useTranslate();
    return (
        <List {...props} empty={<EmptyList entity={entity} />} title={translate('groupEvents.title', { _: 'Grup Etkinlikleri' })} exporter={false}>
            <Datagrid>
                <TextField source="name" label={translate('groupEvents.name', { _: 'Grup Adı' })} />
                <FunctionField source="events" render={(r) => r.events ? r.events.length : 'N/A'} label={translate('groupEvents.num_events', { _: 'Etkinlik Sayısı' })} />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export const GroupEventCreate = (props) => {
    const translate = useTranslate();
    return (
        <Create title={translate('groupEvents.new_group', { _: 'Yeni Grup Etkinliği' })} {...props} redirect={"list"}>
            <SimpleForm redirect={"list"}>

                <h3>{translate('groupEvents.basic_details', { _: 'Temel Detaylar' })}</h3>
                <TextInput source="name" fullWidth label={translate('groupEvents.name', { _: 'Grup Adı' })} validate={required()} />
                <InputRow>
                    <DateInput source="startDate" label={translate('groupEvents.start_date', { _: 'Başlangıç Tarihi' })} validate={required()} fullWidth />
                    <DateInput source="endDate" label={translate('groupEvents.end_date', { _: 'Bitiş Tarihi' })} validate={required()} fullWidth />
                </InputRow>
                
                <TranslatableInputs locales={['en', 'tr']} defaultLocale='en' className="ti44">
                    <TextInput source={"description"} label={translate('groupEvents.description', { _: 'Açıklama' })} validate={required()} fullWidth multiline rows={5} />
                </TranslatableInputs>

                <h3>{translate('pushNotifications.actions', { _: 'İşlemler' })}</h3>
                <BooleanInput source="hasMultipleVenues" label={translate('groupEvents.multiple_venues', { _: 'Bu grup etkinliği birden fazla mekanda mı gerçekleşiyor?' })} helperText={translate('groupEvents.multiple_venues_help', { _: 'Sadece birden fazla mekan varsa aktif edin.' })} />

                <h3>{translate('venues.media', { _: 'Medya' })}</h3>
                <TextInput source="videoURL" label={"Video ID (Youtube ID)"} fullWidth defaultValue={null} />
                <ImageInput source="banner" label={translate('venues.banner', { _: 'Kapak Görseli' })} accept="image/*" validate={required()} defaultValue={null}>
                    <ImageField source="src" title="title" />
                </ImageInput>

                <h3>{translate('events.title', { _: 'Etkinlikler' })}</h3>
                <UpcomingEventsSelectInput />

            </SimpleForm>
        </Create>
    );
};

export const GroupEventEdit = (props) => {
    const translate = useTranslate();
    return (
        <Edit title={translate('groupEvents.edit_group', { _: 'Grup Etkinliğini Düzenle' })} {...props} redirect={"list"}>
            <SimpleForm redirect={"list"}>
                <EditForm />
            </SimpleForm>
        </Edit>
    );
};

const EditForm = () => {
    const translate = useTranslate();
    const [locale] = useLocaleState();
    const localeNameKey = locale === 'tr' ? 'name.tr' : 'name.en';
    const { record, isLoading } = useEditContext();
    if (isLoading) return null;

    return (
        <React.Fragment>
            <h3>{translate('groupEvents.basic_details', { _: 'Temel Detaylar' })}</h3>
            <TextInput source="name" fullWidth label={translate('groupEvents.name', { _: 'Grup Adı' })} validate={required()} />
            <InputRow>
                <DateInput source="startDate" label={translate('groupEvents.start_date', { _: 'Başlangıç Tarihi' })} validate={required()} fullWidth />
                <DateInput source="endDate" label={translate('groupEvents.end_date', { _: 'Bitiş Tarihi' })} validate={required()} fullWidth />
            </InputRow>
            
            <TranslatableInputs locales={['en', 'tr']} defaultLocale='en' className="ti44">
                <TextInput source={"description"} label={translate('groupEvents.description', { _: 'Açıklama' })} validate={required()} fullWidth multiline rows={5} />
            </TranslatableInputs>

            <h3>{translate('pushNotifications.actions', { _: 'İşlemler' })}</h3>
            <BooleanInput source="hasMultipleVenues" label={translate('groupEvents.multiple_venues', { _: 'Bu grup etkinliği birden fazla mekanda mı gerçekleşiyor?' })} helperText={translate('groupEvents.multiple_venues_help', { _: 'Sadece birden fazla mekan varsa aktif edin.' })} />

            <h3>{translate('venues.media', { _: 'Medya' })}</h3>
            <TextInput source="videoURL" label={"Video ID (Youtube ID)"} fullWidth />
            <ImageInput source="banner" label={translate('venues.banner', { _: 'Kapak Görseli' })} accept="image/*" validate={required()} defaultValue={null}>
                <ImageField source="src" title="title" />
            </ImageInput>

            <h3>{translate('events.title', { _: 'Etkinlikler' })}</h3>
            <UpcomingEventsSelectInput record={record} />

            <h3>{translate('groupEvents.homepage_categories', { _: 'Ana Sayfa Gösterim Kategorileri' })}</h3>                
            <span>
                <small>{translate('groupEvents.homepage_categories_help', { _: 'Bu grup etkinliğinin ana sayfada gösterileceği kategoriler.' })}</small>
            </span>
            <ReferenceArrayInput source="homeCategories" reference="categories" defaultValue={[]}>
                <SelectArrayInput optionText={localeNameKey} fullWidth label={translate('groupEvents.select_categories', { _: 'Kategorileri Seçin' })} defaultValue={[]} />
            </ReferenceArrayInput>

        </React.Fragment>
    );
};

